<div class="wrapper">
    <div class="clearfix"></div>
    <div class="title-menu-wrapper">
        @if (!isBrandRating) {
            <div class="title">Shop By Category</div>
        } @else {
            <div class="title" [ngClass]="{ 'pos-center': brandId === 1 }">Order Now</div>
        }
    </div>

    <div class="category-items-wrapper">
        @if (isLoading) {
            @for (loader of loadingCategories; track loader) {
                <div class="category-items">
                    <div class="image-wrapper">
                        <img src="{{ DEPLOY_URL }}/assets/images/missing.png" appDeferImageLoad alt="category" />
                    </div>
                </div>
            }
        }

        @if (!isLoading) {
            @for (category of selectedCategories | categoryFilter: brandId; track category) {
                <div
                    class="category-items"
                    role="button"
                    tabindex="0"
                    (click)="showMenuClick(category)"
                    data-test="landing-page-category">
                    <div class="image-wrapper">
                        <img
                            src="{{ DEPLOY_URL }}/assets/images/missing.png"
                            appDeferImageLoad
                            [imageSrc]="category.image"
                            [alt]="category.description" />
                    </div>
                </div>
            }
        }
    </div>
</div>
